import feedbackActionTypes from '../actionTypes'

const initialState = {
  data: [],
  stats: {
    total: 0,
    unresolved: 0,
    resolved: 0,
    averageRating: 0
  },
  totalPages: 1,
  params: {}
}

const feedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case feedbackActionTypes.GET_FEEDBACK:
      return {
        ...state,
        data: action.payload.data,
        stats: action.payload.stats,
        totalPages: action.payload.totalPages,
        params: action.payload.params
      }
    case feedbackActionTypes.RESPOND_TO_FEEDBACK:
      return {
        ...state,
        data: state.data.map(item => (
          item.id === action.payload.id 
            ? { ...item, response: action.payload.message, responded_at: new Date().toISOString() } 
            : item
        ))
      }
    case feedbackActionTypes.MARK_FEEDBACK_RESOLVED:
      return {
        ...state,
        data: state.data.map(item => (
          item.id === action.payload.id 
            ? { ...item, resolved: true } 
            : item
        )),
        stats: {
          ...state.stats,
          unresolved: state.stats.unresolved - 1,
          resolved: state.stats.resolved + 1
        }
      }
    default:
      return state
  }
}

export default feedbackReducer
